import { Box, Container, Typography } from '@mui/material';
import { getTranslation } from 'common';
import { useTranslations } from 'hooks';
import { useEffect } from 'react';

interface StatItemProps {
    value: string;
    label: string;
}

const StatItem = ({ value, label }: StatItemProps) => (
    <Box
        sx={{
            textAlign: 'center',
            flex: 1,
            p: 6
        }}
    >
        <Typography
            variant="h2"
            component="div"
            sx={{
                // fontWeight: 700,
                // fontSize: { xs: '2.5rem', md: '3.5rem' },
                color: 'text.primary',
                mb: 1,
            }}
        >
            {value}
        </Typography>
        <Typography
            variant="body1"
            sx={{
                color: 'text.secondary',
                // fontSize: { xs: '0.875rem', md: '1rem' },
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                // fontWeight: 500,
            }}
        >
            {label}
        </Typography>
    </Box>
);

const LandingPageStats = ({ lang }: { lang?: string }) => {
    const translations = useTranslations();
    useEffect(() => {
        if (lang) {
            // console.log("LandingPageStats lang:", lang);
        }
    }, [lang]);

    const stats = [
        { value: '6', label: getTranslation(translations, "landing_page.supported_languages") },
        { value: '12+', label: getTranslation(translations, "landing_page.node_types") },
        { value: '100%', label: getTranslation(translations, "landing_page.cloud_native") },
        { value: '24/7', label: getTranslation(translations, "landing_page.monitoring") },
    ];

    return (
        <Box
            id="statistics"
            sx={{
                py: { xs: 6, md: 10 },
                backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? theme.palette.background.paper : '#f8f9fa',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 4, sm: 2, md: 4 },
                        alignItems: 'center',
                        justifyContent: 'space-around',
                    }}
                >
                    {stats.map((stat, index) => (
                        <StatItem key={index} value={stat.value} label={stat.label} />
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default LandingPageStats;
